import React, { FC, useEffect } from "react";
import { Marker, useMap } from "react-leaflet";

type Props = {
  position: [number, number];
  setPosition: (pos: [number, number]) => void;
};

export const DraggableMarker: FC<Props> = ({ position, setPosition }) => {
  const map = useMap();

  const isValidPosition = (
    pos: [number | null, number | null]
  ): pos is [number, number] => pos[0] !== null && pos[1] !== null;

  useEffect(() => {
    if (!isValidPosition(position)) return;
    map.setView(position, map.getZoom());
  }, [position, map]);

  if (!isValidPosition(position)) return null;

  return (
    <Marker
      position={position}
      draggable
      eventHandlers={{
        dragend: (e) => {
          const marker = e.target;
          const newPos: [number, number] = [
            marker.getLatLng().lat,
            marker.getLatLng().lng,
          ];
          setPosition(newPos);
        },
      }}
    />
  );
};
